import { render, staticRenderFns } from "./posterior.vue?vue&type=template&id=660d2d31&scoped=true"
import script from "./posterior.vue?vue&type=script&lang=js"
export * from "./posterior.vue?vue&type=script&lang=js"
import style0 from "./posterior.vue?vue&type=style&index=0&id=660d2d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d2d31",
  null
  
)

export default component.exports